import { render } from "./application-form.vue?vue&type=template&id=78bd12a5&ts=true"
import script from "./application-form.vue?vue&type=script&lang=ts"
export * from "./application-form.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__